{
  "filters": {
    "clear": "Clear",
    "filters": "Filters",
    "filter_input": "Filter...",
    "not_found": "No filters found",
    "tooltip": "Open Filters",
    "alerts": {
      "title": "Alerts"
    },
    "states": {
      "title": "Nodes",
      "all": "Total Nodes",
      "activated": "Activated",
      "deactivated": "Deactivated",
      "hibernated": "Hibernated",
      "idle": "Idle",
      "active": "Active",
      "resolved": "Resolved",
      "online": "Online",
      "offline": "Offline",
      "leased": "Leased",
      "shared": "Shared"
    },
    "thiamis-debug-tag": {
      "title": "Tags"
    },
    "tags": {
      "title": "Tags",
      "membership": "Membership",
      "formation_request": "New Organization Request",
      "partnership": "Partnership",
      "alert": "Alert",
      "message": "Message"
    },
    "status": {
      "title": "Status"
    },
    "channels": {
      "title": "Channels"
    },
    "thiamis": {
      "title": "Thiamis"
    },
    "device": {
      "title": "Devices"
    },
    "devices": {
      "title": "Devices"
    },
    "sensors": {
      "title": "Sensors"
    },
    "partners": {
      "title": "Partners"
    },
    "org": {
      "title": "Partners"
    },
    "archive": {
      "type": {
        "title": "File Types"
      },
      "tag": {
        "title": "Tags"
      }
    },
    "message": {
      "type": {
        "title": "Message Types",
        "all": "Total Messages",
        "alerts": "Alerts",
        "notifications": "Notifications"
      }
    },
    "filter-groups": {
      "partnership-organization": "Organization",
      "api-permission": "Permissions",
      "org-partnerships": "Partnerships",
      "user-role": "Role",
      "last-login": "Last login",
      "user-organization": "Organization",
      "device-status": "Status",
      "alert-status": "Status",
      "firmware-status": "Status",
      "firmware-thiamis": "Device",
      "device-type": "Device",
      "calibration-status": "Status",
      "calibration-sensor": "Sensor",
      "calibration-ready": "Ready",
      "sensors": "Sensors",
      "tags": "Tags",
      "report-type": "Type",
      "reporting-period": "Reporting period",
      "widget-type": "Widget"
    },
    "filter-tags": {
      "org-partnerships": {
        "with-partners": "With partners",
        "no-partners": "No partners"
      },
      "user-role": {
        "owner": "Owner",
        "manager": "Manager",
        "user": "User",
        "admin": "Admin",
        "partner": "Partner",
        "support": "Support"
      },
      "last-login": {
        "last-7-days": "Last 7 days",
        "last-30-days": "Last 30 days",
        "over-90-days": "Over 90 days",
        "never": "Never"
      },
      "alert-status": {
        "activated": "Activated",
        "deactivated": "Deactivated",
        "active": "Active",
        "resolved": "Resolved",
        "idle": "Idle"
      },
      "device-status": {
        "activated": "Activated",
        "deactivated": "Deactivated",
        "hibernated": "Hibernated",
        "offline": "Offline",
        "online": "Online",
        "good": "Good",
        "moderate": "Moderate",
        "poor": "Poor",
        "shared": "Shared",
        "leased": "Leased"
      },
      "firmware-status": {
        "removed": "Removed",
        "available": "Available"
      },
      "device-type": {
        "airthinx": "Aethair IAQ",
        "airthinxpro": "Aethair Pro",
        "airthinx2": "Aethair IAQ 2",
        "driq": "Driq",
        "healthway": "Purifier",
        "inventory": "Inventory",
        "thiamis-1000": "Thiamis-1000",
        "thiamis-1ks": "Thiamis 4GS",
        "thiamis-x": "Thiamis-X"
      },
      "calibration-status": {
        "ok": "Passed",
        "not_run": "Not Run",
        "fail": "Failed"
      },
      "calibration-ready": {
        "yes": "Yes",
        "no": "No"
      },
      "report-type": {
        "air_quality": "Air Quality",
        "aethair_cms_2567": "Aethair CMS-2567",
        "perimeter_monitor": "Perimeter Monitoring"
      },
      "widget-type": {
        "chart_widget": "Chart",
        "chart_table_widget": "Chart Table",
        "node_widget": "Device",
        "heatmap_widget": "Parameter",
        "distribution_widget": "Distribution",
        "map_widget": "Map",
        "blocks_widget": "Block"
      }
    }
  },
  "mentions": {
    "hint": "You can add tags using @",
    "create": "Create"
  }
}